import type { MarketResponseDto } from "Infrastructure/Api/Api";
import { useMemo } from "react";

type B2BOption = { label: string; value: string };

/**
 * Custom hook to get B2B options based on the market.
 */
export function useB2B(market: MarketResponseDto | null | undefined) {
	const b2bOptions = useMemo<B2BOption[]>(() => {
		const defaultOption = { label: "None", value: "" };

		if (!market?.b2bOptions) {
			return [];
		}

		try {
			const parsedOptions = JSON.parse(market.b2bOptions);
			return [defaultOption, ...parsedOptions];
		} catch (_error) {
			return [];
		}
	}, [market?.b2bOptions]);

	return { b2bOptions };
}
